import { ProgressSpinner } from 'primereact/progressspinner';

export default function Loading() {
    return (
        <div style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%'
        }}>
            <ProgressSpinner />
        </div>
    )
}